// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BandChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BandChartIcon" ref={forwardedRef} {...props}>
      <path d="M3 3h1.5v12.5H17V17H4a1 1 0 0 1-1-1z" />
      <path d="m8.25 6.25 4 2.2L17 5v6l-4.75 2-4-2.75-3.75 2.084V9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BandChartIcon = /* @__PURE__ */ Object.assign(
  BandChartIconComponent,
  { displayName: 'BandChartIcon' },
);
